import { createReducer } from '@reduxjs/toolkit';

import { StatisticsStreamingInit } from 'redux/reducers/init';

import {
  requestStatisticsStreaming,
  requestStatisticsStreamingSuccess,
  requestStatisticsStreamingFailure,
} from 'redux/actions/statistics/actions';

/**
 * Reducers
 */
const statisticsStreaming = createReducer(StatisticsStreamingInit, {
  [requestStatisticsStreaming.type]: (state, action: RequestStatisticsStreamingAction) => {
    state.isLoading = true;
  },
  [requestStatisticsStreamingSuccess.type]: (
    state,
    action: RequestStatisticsStreamingSuccessAction,
  ) => {
    const { statisticsStreaming } = action.payload;
    state.isLoading = false;
    state.statistics = statisticsStreaming;
  },
  [requestStatisticsStreamingFailure.type]: (
    state,
    action: RequestStatisticsStreamingFailureAction,
  ) => {
    state.isLoading = false;
    state.statistics = [];
  },
});

export default statisticsStreaming;
